<template>
  <div>
    <video-player
      class="video-player-box"
      ref="videoPlayer"
      :options="playerOptions"
      :playsinline="true"
    >
    </video-player>
  </div>
</template>

<script>
export default {
  props: {
    url: String,
  },
  data() {
    return {
      playerOptions: {
        // videojs options
        muted: false,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        width: "800px",
        sources: [
          {
            type: "video/mp4",
            src: this.url,
          },
        ],
      },
    };
  },
  mounted() {
    this.playerOptions.sources[0].src = this.url;
  },
  watch: {
    url() {
      this.playerOptions.sources[0].src = this.url;
    },
  },
};
</script>

<style lang="scss">
.video-player-box {
  margin: auto;
  width: 50vw !important;
  align-content: center;
  align-items: center;
  text-align: center;
}
</style>